<template>
    <span>
        <b-button
            title="Edit"
            variant="default"
            @click="openCampaign"
        >
            <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
        </b-button>
    </span>
</template>

<script>
    export default {
        components: {
            //
        },
        data() {
            return {
                //
            };
        },
        computed: {
            //
        },
        methods: {
            openCampaign() {
                this.$router.push(`/app/staylio-app/mass-push-notification/${this.params.data.id}/`);
            }
        },
    };
</script>
